import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const finish = (path) => {
      window.history.replaceState(null, "", window.location.pathname);
      navigate(path, { replace: true });
    };
    if (!sessionId) {
      finish("/login");
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then((res) => {
        applySession(res.data);
        finish("/");
      })
      .catch(() => finish("/login"));
  }, [applySession, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0b1610]">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-white/20 border-t-[#E8611A]" />
        <p className="mt-4 text-sm font-medium text-emerald-100">Entrando...</p>
      </div>
    </div>
  );
}
